export interface LogoutConfig {
  url: string;
  state: string;
}

export interface StateParam {
  targetUrl: {
    countryCode: string;
    relativeUrl: string;
    redirectHost?: string;
    query?: Record<string, unknown>;
    fragment?: string;
  };
  accountManager?: {
    shipTo: string;
  };
}

export enum RequestParam {
  STATE = 'state',
  CUSTOMER_ID = 'origin_customer_id',
  CONTACT_ID = 'origin_contact_id',
  COUNTRY = 'country',
  LANG = 'lang'
}

export enum OauthUserType {
  DEFAULT = 'DEFAULT',
  AM = 'AM',
  EVOUCHER = 'EVOUCHER'
}

export interface ContextIds {
  customerId?: string;
  contactId?: string;
  shipToId?: string;
}

export type UserUrlMap = ReadonlyMap<OauthUserType, string>;
